import React from 'react';
import { Box } from '@mui/material';
import Markdown, { Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';

const components: Components = {
  a: ({ href, children, title }) =>
    href ? (
      <a href={href} title={title} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    ) : (
      <span>{children}</span>
    ),
  table: ({ children }) => (
    <Box sx={{ maxWidth: '100%', overflowX: 'auto', my: 1.5 }}>
      <table>{children}</table>
    </Box>
  ),
};
const plugins = [remarkGfm];

export const MarkdownMessage = ({ text }: { text: string }) => (
  <Box
    sx={{
      typography: 'body1',
      lineHeight: 1.65,
      overflowWrap: 'anywhere',
      '& > :first-child': { mt: 0 },
      '& > :last-child': { mb: 0 },
      '& p': { my: 1.25 },
      '& h1, & h2, & h3, & h4, & h5, & h6': {
        fontSize: '1.05em',
        fontWeight: 600,
        lineHeight: 1.4,
        mt: 2,
        mb: 1,
      },
      '& h1, & h2': { fontSize: '1.15em' },
      '& ul, & ol': { my: 1.25, pl: 3 },
      '& li': { my: 0.5 },
      '& li > p, & li > ul, & li > ol': { my: 0.5 },
      '& a': { color: 'primary.main', textUnderlineOffset: '2px' },
      '& blockquote': {
        mx: 0,
        my: 1.5,
        pl: 1.5,
        borderLeft: 3,
        borderColor: 'divider',
        color: 'text.secondary',
      },
      '& code': {
        fontFamily: 'monospace',
        fontSize: '0.875em',
        bgcolor: 'action.hover',
        borderRadius: 0.5,
        px: 0.5,
      },
      '& pre': {
        m: 0,
        my: 1.5,
        p: 1.5,
        bgcolor: 'action.hover',
        borderRadius: 1,
        overflowX: 'auto',
        whiteSpace: 'pre',
      },
      '& pre code': { p: 0, bgcolor: 'transparent' },
      '& table': { borderCollapse: 'collapse', width: '100%' },
      '& th, & td': {
        border: 1,
        borderColor: 'divider',
        p: 1,
        verticalAlign: 'top',
      },
      '& th': { bgcolor: 'action.hover', fontWeight: 600 },
      '& hr': { border: 0, borderTop: 1, borderColor: 'divider', my: 2 },
    }}
  >
    <Markdown
      remarkPlugins={plugins}
      components={components}
      skipHtml
      disallowedElements={['img']}
    >
      {text}
    </Markdown>
  </Box>
);
